import m from "mithril";
import ModalManager from "../../shared/modal";
import i18n from "../../shared/i18n/i18n";

let modalId;

const Modal_Assessment_Result = {
    message: "",
    vnodeRef: null,

    setModalId(id) {
        modalId = id;
    },

    submit() {
        const { callback, isPassed, unitEnrolment, user } = this.vnodeRef.attrs;

        if (typeof callback === "function") {
            if (isPassed) {
                callback(
                    unitEnrolment,
                    true,
                    i18n.t("assessment_passed_continue"),
                    user
                );
            } else {
                callback(unitEnrolment, false, this.message, user, true);
            }
        }

        this.message = "";
        ModalManager.close(modalId);
    },

    view(vnode) {
        this.vnodeRef = vnode;
        const { isPassed } = vnode.attrs;

        if (isPassed && !this.message) {
            this.message = i18n.t("assessment_assessed_successfully");
        }

        const canSubmit = isPassed || !!this.message.trim();

        return [
            isPassed
                ? m(".form-section", [
                    m(".form-label", i18n.t("passed_message"))
                ])
                : m(".form-section.required", [
                    m(".form-label", [
                        i18n.t("assessment_return_message"),
                        m("br"), m("br"),
                        i18n.t("learner_feedback")
                    ]),
                    m("textarea.message", {
                        value: this.message,
                        oninput: e => this.message = e.target.value
                    })
                ]),

            m(".form-buttons", [
                m("button", {
                    class: canSubmit ? "" : "btn-text no-click",
                    onclick: canSubmit ? () => this.submit() : null
                }, isPassed ? i18n.t("passed") : i18n.t("not_yet_competent"))
            ])
        ];
    }
};

export default Modal_Assessment_Result;
